module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_93-a4f90fc3cf0d2646325ee14e30365804.png";